import GenerateData from './generate-data.js';
import SecureAuthenticator from '../../utils/secure-authenticator.js';
import { AnalyticsData, WorkFlowSummeryData } from './constants.js';

class HomePage extends GenerateData {
  #auth;

  constructor(auth) {
    super();
    this.#auth = auth;
  }

  #setupPasswordVisibility() {
    const eyesWrap = document.querySelector("[wrapper='eye']");
    // eslint-disable-next-line sonarjs/no-hardcoded-passwords
    const openEye = eyesWrap?.querySelector("[password='hide']");
    // eslint-disable-next-line sonarjs/no-hardcoded-passwords
    const closeEye = eyesWrap?.querySelector("[password='show']");

    eyesWrap?.addEventListener('click', () => {
      const passField = document.querySelector("[field='password']");
      if (!passField) return;

      const isPassword = passField.type === 'password';
      passField.type = isPassword ? 'text' : 'password';
      closeEye?.classList.toggle('hide');
      openEye?.classList.toggle('hide');
    });
  }

  #setupFormSubmission() {
    const formElm = document.querySelector('#wf-form-Login-Form');

    formElm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const username = event.target[0].value.trim();
      const password = event.target[2].value.trim();
      try {
        const isValid = await this.#auth.verifyCredentials(username, password);

        if (isValid) {
          await this.generateData('AnalyticsData', AnalyticsData);
          await this.generateData('WorkflowSummeryData', WorkFlowSummeryData);

          globalThis.location.href = '/workflows';
        }
      } catch (error) {
        alert(error.message);
      }
    });
  }

  initialize() {
    this.#setupPasswordVisibility();
    this.#setupFormSubmission();
  }
}

(() => {
  // username: demo@e5.ai
  // password: Test123$
  // If you want to modify username and password for security reason,
  //   then you will update the username and password in src/utils/secure-credential-generator.js
  //   and run ```nvm use && node src/utils/secure-credential-generator.js```
  if (globalThis.location.pathname === '/') {
    const auth = new SecureAuthenticator(
      {
        encryptedCredentials:
          // eslint-disable-next-line max-len
          'fbf98f4c648d582f71c76757d09932ba5fa4ca7bb7c61ad2e65ad618e00773b3d085c0813b73b45276f529bec6a16fb4168c8e462f119ab5a20e3a30d7f3d0250bad459a0ea6354ce2bd7256a954214f',
        iv: '0467e54036b8f7b90e542f14',
        usernameSalt: 'd150c58b9f115c3a38ee8e3ce93e33e9',
        // eslint-disable-next-line sonarjs/no-hardcoded-passwords
        passwordSalt: '18119cc0a63b610ff46ac77749444a61',
      },
      '004ae5865ec758247fc46676984c02847215f13444065c4182e9cfee6a1ef029'
    );
    const home = new HomePage(auth);
    home.initialize();
  }
})();
